import { AxiosResponse } from 'axios';
import { apiClient, getAuthHeaders } from './index';
import { TokenState } from './types';
import { TokenCategory } from '../../stores/data/types';

export const noteApi = {
  /**
   * 토큰 노트 내용(contents)만 업데이트합니다.
   * @param tokenAddress 토큰 주소
   * @param contents 노트 내용 (null: 리셋)
   * @returns 업데이트된 Token State
   */
  async updateTokenNote(
    tokenAddress: string,
    contents: string | null
  ): Promise<TokenState> {
    try {
      const response: AxiosResponse<any> = await apiClient.patch(
        `/fe-management-system/token-states/${tokenAddress}/note`,
        { contents },
        {
          headers: getAuthHeaders(),
        }
      );

      return response.data.data;
    } catch (error) {
      console.error('❌ PATCH /fe-management-system/token-states/:tokenAddress/note 에러:', error);
      throw error;
    }
  },

  /**
   * 컨텐츠 생성을 위한 정보를 제출합니다. 상태를 "Fetching Data"로 전환합니다.
   * @param tokenAddress 토큰 주소
   * @param request 컨텐츠 생성 정보
   * @returns 업데이트된 Token State
   */
  async submitForContentGeneration(
    tokenAddress: string,
    request: {
      socialSources?: Array<{
        sourceType: 'X_TWEET' | 'X_ACCOUNT' | 'X_COMMUNITY';
        sourceKey: string;
        from: Date;
        to: Date;
      }>;
      projectSiteUrl?: string | null;
      category?: TokenCategory;
    }
  ): Promise<TokenState> {
    try {
      const response: AxiosResponse<any> = await apiClient.post(
        `/fe-management-system/token-states/${tokenAddress}/content-generation`,
        request,
        {
          headers: getAuthHeaders(),
        }
      );

      return response.data.data;
    } catch (error) {
      console.error('❌ POST /fe-management-system/token-states/:tokenAddress/content-generation 에러:', error);
      throw error;
    }
  },
  /**
   * Dexscreener에서 토큰 정보를 가져와 노트를 갱신합니다.
   * @param tokenAddress 토큰 주소
   * @returns 업데이트된 Token State
   */
  async refreshFromDexScreener(tokenAddress: string): Promise<TokenState> {
    try {
      const response: AxiosResponse<any> = await apiClient.patch(
        `/fe-management-system/token-states/${tokenAddress}/note/dex-screener`,
        {},
        {
          headers: getAuthHeaders(),
        },
      );

      return response.data.data;
    } catch (error) {
      console.error('❌ PATCH /fe-management-system/token-states/:tokenAddress/note/dex-screener 에러:', error);
      throw error;
    }
  },
};
